export function initNotificationsAdmin(_root: HTMLElement): void {
    // Mark-all lives in {block pageActions} (page header), outside [data-system-page].
    const markAllButton = document.querySelector<HTMLAnchorElement>('#naisNotificationsMarkAll');
    const markAllUrl = markAllButton?.dataset.markAllUrl ?? markAllButton?.getAttribute('href') ?? '';

    if (!markAllButton || !markAllUrl || markAllUrl === '#') {
        return;
    }

    markAllButton.addEventListener('click', (event) => {
        event.preventDefault();
        $.nette.ajax({ url: markAllUrl });
    });
}
